import {combineReducers} from "redux";
import Shop from "../_data/models/Shop";
import {Action} from "redux-actions";
import Meta from "../_data/models/Meta";
import {
    clearShopProfile,
    didReceiveShopProfessionals, didReceiveShops, invalidateShops, requestFailed, requestShopProfessionals,
    requestStarted,
    requestSucceeded, setMyShopsFilter
} from "./actions";
import {Map} from "immutable";
import {boothCollectionReducer} from "../booth/reducers";
import {ActiveModalState} from "../_definitions/styleteq";
import activeModalReducer from "../_widgets/modal/reducer";

//interfaces
interface ShopsListAction {
    ids: Map<number, number>;
    filter: string;
    meta: Meta;
}

interface ShopDependencyAction {
    ids: Map<number, number>;
    meta: Meta
}


export const myShopsReducer = combineReducers({
    ids: myShopsList,
    filter: shopsListFilter,
    meta,
    loading,
    errors
});
export default myShopsReducer;

function shopsListFilter(state: string = null, action: Action<ShopsListAction>) {
    switch (action.type) {
        case setMyShopsFilter.toString(): {
            return action.payload.filter;
        }
        case invalidateShops.toString(): {
            return null;
        }
    }
    return state;
}




//-- start shop professionals reducers
export const shopProfessionals = combineReducers({
    ids: shopProfessionalItems,
    meta: shopProfessionalMeta,
    loading: shopProfessionalIsLoading
});

function shopProfessionalItems(state: Map<number, number> = Map<number, number>(), action: Action<ShopDependencyAction>) {

    switch (action.type) {
        case didReceiveShopProfessionals.toString():
            return state.mergeDeep(action.payload.ids);
        case clearShopProfile.toString():
            return Map<number, number>();
    }
    return state;
}

function shopProfessionalMeta(state: Meta = null, action: Action<ShopDependencyAction>) {

    switch (action.type) {
        case didReceiveShopProfessionals.toString():
            return action.payload.meta;
    }
    return state;
}

function shopProfessionalIsLoading(state: boolean = false, action: Action<ApiRequestAction>) {
    switch (action.type) {
        case requestShopProfessionals.toString():
            return true;
        case didReceiveShopProfessionals.toString():
            return false;
    }

    return state;
}
//-- end shop professionals reducers

//-- shop profile
export const shopProfileReducer = combineReducers({
    professionals: shopProfessionals,
    booths: boothCollectionReducer,
    activeModal: activeModalReducer
});


function myShopsList(state: Map<number, number> = Map<number, number>(), action: Action<ShopsListAction>) {

    switch (action.type) {
        case invalidateShops.toString():
            return Map<number, number>();
        case didReceiveShops.toString():
            return state.mergeDeep(action.payload.ids);
    }
    return state;
}




function errors(state: string[] = [], action: Action<ApiRequestAction>) {
    switch (action.type){
        case requestStarted.toString():
            return [];
        case requestSucceeded.toString():
            return [];
        case requestFailed.toString():
            return action.payload.requestErrors
    }

    return state;
}

function loading(state: boolean = false, action: Action<ApiRequestAction>){
    switch (action.type){
        case requestStarted.toString():
            return true;
        case requestSucceeded.toString():
            return false;
        case requestFailed.toString():
            return false;
    }

    return state;
}

function meta(state: Meta = null, action: Action<ShopsListAction>) {
    switch (action.type) {
        case didReceiveShops.toString():
            return action.payload.meta;
    }

    return state;
}


// WEBPACK FOOTER //
// ./app/client/shop/reducers.ts